import { GameRandom, ModelEvents } from "@denishussar/html5-game-engine";
import { Inject, Singleton } from "@denishussar/html5-game-engine";

export enum LoanThingsEnum {
  phone = "phone",
  bitkoin = "bitkoin",
  ticket = "ticket",
  egg = "egg",
  car = "car",
  macbook = "macbook",
}

export enum LoanAvatarEnum {
  blonde = "blonde",
  old_man = "old_man",
  brunette = "brunette",
  boy = "boy",
  baby = "baby",
  man = "man",
}

@Singleton
export class LoanModel {
  public buttons: [string, string] = ["approve", "refuse"];
  public things: LoanThingsEnum = LoanThingsEnum.phone;
  public avatars: LoanAvatarEnum = LoanAvatarEnum.blonde;
  public name: string = "purple";

  constructor(
    @Inject private _$random: GameRandom,
    @Inject private _$modelEvents: ModelEvents
  ) {}
}
